import axios from 'axios'
import * as uploadApi from '@/api/upload'

export function put({ name, file, type }, options = {}) {
  try {
    const extension = getFileExtention(file.name)

    if (!type) {
      type = getFileType(extension)
    }
    const fileName = name + '.' + extension

    return uploadApi.presignedUrl(fileName, type.toLowerCase()).then(res => {
      const { uploadUrl, host } = res.data
      return axios.put(uploadUrl, file, {
        headers: { 'Content-Type': file.type || 'application/octet-stream' },
        onUploadProgress: options.progress ? (e) => {
          options.progress(e.loaded / e.total)
        } : undefined
      }).then(() => {
        return { url: host + fileName, type }
      })
    })
  } catch (e) {
    console.log(e)
  }
}

export function getFileExtention(name) {
  const tmpcnt = name.lastIndexOf('.')
  return name.substring(tmpcnt + 1)
}

export function getFileType(extension) {
  if (extension.includes('.')) {
    extension = getFileExtention(extension)
  }
  if (isImage(extension)) {
    return 'IMAGE'
  } else if (isVideo(extension)) {
    return 'VIDEO'
  } else {
    return 'IMAGE'
  }
}

export function isImage(name, extensions = ['jpg', 'jpeg', 'png', 'bmp']) {
  const extension = getFileExtention(name)
  return extensions.includes(extension.toLowerCase())
}

export function isVideo(name) {
  const extension = getFileExtention(name)
  return ['mp4'].includes(extension.toLowerCase())
}
